export default "__VITE_ASSET__mz8p5oGl__"